import { useCallback } from 'react'

import { useAuth } from '@/features/auth'
import { useGetFeatureFlags } from '@/features/auth/api/useGetFeatureFlags'

import { Features } from './features'

export const useFeatureFlag = () => {
  const { isAuthenticated } = useAuth()
  const featureNames = Object.values(Features)

  const { data: featureFlagsData, isPending: isFeatureFlagsLoading } = useGetFeatureFlags(featureNames, isAuthenticated)

  const isFeatureEnabled = useCallback(
    (featureName: Features): boolean => {
      return (featureFlagsData?.flags ?? []).find((featureFlag) => featureFlag.name === featureName)?.enabled ?? false
    },
    [featureFlagsData]
  )

  return {
    isFeatureEnabled,
    isFeatureFlagsLoading: isAuthenticated ? isFeatureFlagsLoading : null,
  }
}
